<template>
  <div class="head-box">
    <header>
      <div class="small-box">
        <div class="head-left">
          <p>欢迎访问中国民主同盟{{ committee }}委员会</p>
          <p>
            <span>今天是：</span>
            <span>{{ new Date().getTime() |parseTime('{y}年{m}月{d}日 星期{a}') }} </span>
          </p>
          <p class="weather">
            <span>天气预报：</span>
            <iframe id="weatherFrame" scrolling="no" src="https://tianqiapi.com/api.php?style=ta&amp;skin=pitaya&amp;color=367DBE&amp;font-size=1" frameborder="0" width="360" height="19" color="FF4040" allowtransparency="true" />
          </p>
        </div>
        <div class="head-right">
          <input v-model="title" type="text" @keyup.enter="onSearch">
          <button class="search" @click="onSearch">搜索</button>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: 'HeadTap',
  data() {
    return {
      title: '',
      committee: ''
    };
  },
  mounted() {
    // const titleMaps = new Map([['192.168.1.61', '测试主站'], ['192.168.1.19', '测试子站1号'], ['mmgzsw', '贵州省'], ['guiyang', '贵阳市'], ['asmm', '安顺市'], ['liupanshui', '六盘水'], ['qianxinan', '黔西南州'], ['bijie', '毕节'], ['qiandongnan', '黔东南'], ['qiannan', '黔南']]);
    const titleMaps = new Map([['mmgzsw', '贵州省'], ['guiyang', '贵阳市'], ['asmm', '安顺市'], ['liupanshui', '六盘水'], ['qianxinan', '黔西南州'], ['bijie', '毕节'], ['qiandongnan', '黔东南'], ['qiannan', '黔南'], ['zunyi', '遵义']]);
    titleMaps.forEach((value, key) => {
      const hostname = window.location.hostname;
      if (hostname.indexOf(key) > -1) {
        this.committee = value;
        document.title = value + '民盟'
      }
    })
  },
  methods: {
    // TODO: 跳转搜索页面
    onSearch() {
      const title = this.title.trim();
      this.$router.replace({ path: '/search', query: { title }})
    }
  }
};
</script>

<style lang="less" scoped>
.head-box {
  width: 100%;
  min-width: 1200px;
  height: 50px;
  background: #fff;
  font-family: '宋体';
  .small-box {
    width: 1200px;
    height: 50px;
    margin: 0 auto;
    color: #367dbe;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .head-left {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      position: relative;
      left: 80px;
      bottom: 4px;
      color: #367dbe;
      font-size: 13px;
      top: 0;
      p:nth-child(1) {
        padding-right: 20px;
      }
      p:nth-child(2) {
        padding-right: 20px;
      }
    }
    .head-right {
      display: flex;
      align-items: center;
      position: relative;
      z-index: 1;
      .search {
        height: 25px;
        margin-left: 10px;
        padding: 1px 10px;
        box-sizing: border-box;
        background: #367dbe;
        border: 1px solid #367dbe;
        color: #fff;
        border: 0;
      }
    }
  }
}
.head-right {
  input {
    border: 1px solid #367dbe;
    height: 25px;
    line-height: 25px;
    padding-left: 5px;
    color: #888;
    width: 200px;
  }
}
.weather {
  font-size: 14px;
  color: #367dbe;
  font-family: '宋体';
  font-style: normal;
  display:flex;
  align-items: center;
  span:nth-child(1) {
    font-size: 13px;
  }
  .weather-text {
    background-color: #73d538;
    margin: 0;
    padding: 1px 2px;
    /* display: inline-block; */
    border-radius: 3px;
    color: #fff;
  }
}
</style>
